import type {HalContext} from "@cm/hal/hal-context"
import {runViewTests} from "#webgl2/test/view-tests/view-tests"
import {TestContext} from "#webgl2/test/helpers/test-context"

export const runWebGl2Tests = (halContext: HalContext) => {
    const ctx = new TestContext(halContext)
    runViewTests(ctx)
    ctx.dispose()
}
